import React, { useEffect, useState } from 'react';
import classNames from 'classnames';
import { InfoCircleSolidIcon } from '@mm/icons';
import { Heading } from '@mm/components';
import { ReactComponent as MigrateThanksIcon } from 'assets/migrate-to-ic-thanks-modal-icon.svg';
import styles from './MigrateToInstachampThanksModal.module.css';
import { ModalBody, ModalFooter, CloseModalProps } from '../modal-helpers';
import { useCountdown } from '../../../modules/LoginRouter/components/ResetPasswordForm/use-countdown';
import { PrimaryButton } from '../../buttons/PrimaryButton/PrimaryButton';
import TextInput from '../../components/TextInput';

type OuterProps = {
  onConfirmHandler: () => void;
};
type Props = OuterProps & CloseModalProps;

export const MigrateToInstachampThanksModal = ({
  onConfirmHandler,
  closeModal,
}: Props) => {
  const [step, setStep] = useState(0);
  const [confirmText, setConfirmText] = useState('');
  const countdown = useCountdown(25 * 1000);
  const seconds = countdown.state.timeLeft / 1000;

  const progressMessage = `We are migrating your account to InstaChamp and you will be
  automatically redirected in ${seconds} seconds...`;

  useEffect(() => {
    if (countdown.state.timeLeft === 1000) {
      countdown.actions.reset();
    }
  }, [countdown.state.timeLeft]);

  useEffect(() => {
    if (step === 1) {
      countdown.actions.start();
    }
  }, [step]);

  const StepOne = () => {
    return (
      <>
        <Heading size={3} className={styles.heading}>
          <InfoCircleSolidIcon
            className={styles.icon}
            color="var(--color-accent-blue)"
          />
          Congratulations on choosing InstaChamp Platinum for $9.95/month! If
          you're not satisfied, you may cancel at any time.
        </Heading>
        <Heading size={4} className={styles.heading}>
          Please type <strong>CONFIRM</strong> in the box below to fresh start
          with a new Chatbot and switch to InstaChamp.
        </Heading>
        <TextInput
          autoFocus
          className={styles.input}
          placeholder="Type CONFIRM..."
          onChange={e => {
            setConfirmText(e.currentTarget.value);
          }}
          value={confirmText}
        />
      </>
    );
  };

  const StepTwo = () => {
    return (
      <>
        <MigrateThanksIcon />
        <Heading size={2} className={styles.heading}>
          Congratulations on sticking with your Chat Automation strategy!
        </Heading>
        <Heading size={4} className={styles.heading}>
          {progressMessage}
        </Heading>
      </>
    );
  };

  return (
    <>
      <ModalBody className={styles.modalBody}>
        <div
          className={classNames(styles.container, {
            [styles.centered]: step === 1,
          })}
        >
          {step === 0 && <StepOne />}
          {step === 1 && <StepTwo />}
        </div>
      </ModalBody>
      {step === 0 && (
        <ModalFooter>
          <PrimaryButton color="secondary-blue" onClick={() => closeModal()}>
            Cancel
          </PrimaryButton>
          <PrimaryButton
            onClick={() => {
              setStep(step + 1);
              onConfirmHandler();
            }}
            disabled={confirmText.toLocaleLowerCase() !== 'confirm'}
          >
            Confirm
          </PrimaryButton>
        </ModalFooter>
      )}
    </>
  );
};
